import AuthService from '../services/AuthService';

export default function (to, from, next) {
    AuthService.isAdmin() ? next() : next({name: 'home'});
}